import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from 'vue';
import { IDDescriptionPair } from '@/types/generic/IDDescriptionPair';
import { FieldSize } from '@/enums/system/FieldSize';
import SingleSelect from './single-select.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'irish-counties-single-select',
  props: {
    /** 
     * The string value used with `v-model` to control the visibility or state of a modal or component.
     * @type {string}
     * @required
     */
    modelValue: {
        type: String,
        required: true
    },
    /** 
     * The width of the field, defined by the `FieldSize` enum.
     * @type {FieldSize}
     * @default FieldSize.Full
     */
    width: {
        type: String as PropType<FieldSize>,
        default: FieldSize.Full
    },
    /** 
     * Determines whether the specific input control is required field.
     * @type {boolean}
     * @default false
     */
    requiredInput: {
        type: Boolean,
        default: false
    },
    /** 
    * The label displayed for the control.
    * @type {String}
    * @default 'County'
    */
    label: {
        type: String,
        default: 'County'
    },
    /** 
     * The validation group name used for form validation.
     * @type {string}
     * @default ''
     */
    validationGroup: {
        type: String,
        required: false,
        default: ''
    }
},
  emits: [
    /** 
     * Triggered when the `modelValue` changes.
     * This is used to update the v-model variable in the parent component and control the visibility of the modal.
     * @event update:modelValue
     * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
     */
    'update:modelValue'
],
  setup(__props, { emit }) {

const props = __props;





const county = computed({
    get: () => props.modelValue,
    set: (value: string) => emit('update:modelValue', value)
})

const irishCounties: IDDescriptionPair[] = [
    { id: 0, description: '' },
    { id: 1, description: 'County Carlow' },
    { id: 2, description: 'County Cavan' },
    { id: 3, description: 'County Clare' },
    { id: 4, description: 'County Cork' },
    { id: 5, description: 'County Donegal' },
    { id: 6, description: 'County Dublin' },
    { id: 7, description: 'County Galway' },
    { id: 8, description: 'County Kerry' },
    { id: 9, description: 'County Kildare' },
    { id: 10, description: 'County Kilkenny' },
    { id: 11, description: 'County Laois' },
    { id: 12, description: 'County Leitrim' },
    { id: 13, description: 'County Limerick' },
    { id: 14, description: 'County Longford' },
    { id: 15, description: 'County Louth' },
    { id: 16, description: 'County Mayo' },
    { id: 17, description: 'County Meath' },
    { id: 18, description: 'County Monaghan' },
    { id: 19, description: 'County Offaly' },
    { id: 20, description: 'County Roscommon' },
    { id: 21, description: 'County Sligo' },
    { id: 22, description: 'County Tipperary' },
    { id: 23, description: 'County Waterford' },
    { id: 24, description: 'County Westmeath' },
    { id: 25, description: 'County Wexford' },
    { id: 26, description: 'County Wicklow' }
]

const selectedCountyId = computed({
    get: () => getCountyId(),
    set: (value: number) => county.value = getCountyDescription(value)
});

const getCountyId = () => {
    /* Historical data may not contain 'County' as we didn't enforce this previously
     * This won't account for Co. or Co. However, Jim previously said ignore this */
    const normalizedDescription = county.value.includes('County ') ? county.value : `County ${county.value}`
    const matchedCounty = irishCounties.find(x => x.description === normalizedDescription);

    if (matchedCounty) {
        return matchedCounty.id;
    }

    county.value = '';
    return 0;
}

const getCountyDescription = (countyId: number) => {
    return irishCounties.find(x => x.id === countyId)?.description ?? '';
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SingleSelect, {
    modelValue: selectedCountyId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCountyId).value = $event)),
    "data-source": irishCounties,
    width: props.width,
    "allow-zero-value": !__props.requiredInput,
    "required-input": __props.requiredInput,
    label: __props.label,
    "validation-group": __props.validationGroup
  }, null, 8, ["modelValue", "width", "allow-zero-value", "required-input", "label", "validation-group"]))
}
}

})